export type IconProps = {
    icon?: string;
    className?: string;
}
const Icon = (props: IconProps) => {
    return <i className={`${props.icon} ${props.className}`} />;
   };
    
   export default Icon;